













































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* api */
import GetImageApi from '@/app/model/api/getImageApi'

@Component
export default class FieldImg extends Vue {
  private showImgModal: boolean = false;
  private imagePath: string = ''
  private originalImagePath: string = ''

  @Prop() private plantingId!: number
  @Prop() private imgPath!: string

  private get changeImgPath (): string {
    return this.imgPath
  }
  @Watch('changeImgPath')
  onChangeImgPath (path: string) {
    this.getDefaultData()
  }

  created () {
    this.getDefaultData()
  }

  private async getDefaultData () {
    const img = '/img/ico_barley_02'
    if (this.imgPath.indexOf(img)) {
      if (this.imgPath !== '' && this.imgPath !== undefined) {
        let id = String(this.plantingId)

        /* 初期は昨日の日付で取得 */
        if (id !== '0') {
          let type = ''
          let date = '' + new Date().getFullYear() + ('0' + (new Date().getMonth() + 1)).slice(-2) + ('0' + (new Date().getDate() - 1)).slice(-2)
          let body: any = {
            planting_id: id,
            date: date,
            type: type
          }

          const result = await GetImageApi.getImageData(body)
          this.imagePath = String(result)
        } else {
          this.imagePath = require('@/assets/icon/ico_barley_02.svg')
        }
      } else {
        this.imagePath = require('@/assets/icon/ico_barley_02.svg')
      }
    } else {
      this.imagePath = require('@/assets/icon/ico_barley_02.svg')
    }
  }

  /* モーダルのオリジナル画像を取得 */
  private async showModal (path: string) {
    /* original画像取得 */
    const img = '/img/ico_barley_02'
    if (this.imgPath.indexOf(img)) {
      if (path !== '/img/ico_barley_02.37101e46.svg' && path !== '' && path !== undefined) {
        let id = String(this.plantingId)

        if (id !== '0') {
          let type = 'original'
          let date = '' + new Date().getFullYear() + ('0' + (new Date().getMonth() + 1)).slice(-2) + ('0' + (new Date().getDate() - 1)).slice(-2)

          let body: any = {
            planting_id: id,
            date: date,
            type: type
          }

          const result = await GetImageApi.getImageData(body)
          this.originalImagePath = String(result)
        } else {
          this.originalImagePath = require('@/assets/icon/ico_barley_02.svg')
        }
      } else {
        this.originalImagePath = require('@/assets/icon/ico_barley_02.svg')
      }
    } else {
      this.originalImagePath = require('@/assets/icon/ico_barley_02.svg')
    }

    this.showImgModal = true
  }
}
